module.exports = __webpack_public_path__ + "img/afghanistan.af59f3dd.svg";